import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export function AppShell() {
    return (
        <div className="min-h-screen flex bg-[#F5F7FB]">
            <Sidebar />
            <div className="flex-1 min-w-0 flex flex-col">
                <Topbar />
                <main className="flex-1 px-6 lg:px-8 py-8 animate-fade-in">
                    <div className="max-w-7xl mx-auto w-full">
                        <Outlet />
                    </div>
                </main>
                <footer
                    data-testid="disclaimer-footer"
                    className="border-t border-[#DCE3EE] bg-white px-6 py-4 text-center"
                >
                    <p className="text-xs text-[#64748B] max-w-4xl mx-auto leading-relaxed">
                        IH PEC Guard fornisce supporto tecnico e operativo. Le analisi non
                        costituiscono un parere legale e non sostituiscono la verifica umana.
                    </p>
                    <p
                        data-testid="app-credit"
                        className="text-xs text-[#94A3B8] mt-2"
                    >
                        © 2026 IH PEC Guard — Creato da <span className="font-semibold text-[#64748B]">Ptk Solutions</span>
                    </p>
                </footer>
            </div>
        </div>
    );
}

export default AppShell;
